import React from "react";
import { Link } from "react-router-dom";

export default function NavItem({ href, title, a = false, className = "" }) {
  return (
    <li
      className={`${className} hidden md:block font-sans list-none mx-4 text-white font-bold hover:text-slate-300`}
    >
      {a ? <a href={href}>{title}</a> : <Link to={href}>{title}</Link>}
    </li>
  );
}
